import React from 'react';
import Currency from '../../components/Agreement/Currency';
import TableRow from '../../components/Agreement/TableRow';
import { formatLessonItems } from '../../utils';

const Table = props => {
  const { lessons } = props;
  const { Items, Depositpayment } = lessons;

  return (
    <div className={'table'}>
      <TableRow
        rowClassName={'table-header'}
        data={[
          { value: '编号' },
          { value: '课程' },
          {},
          {},
          { value: '次数' },
          // { value: '单次价钱' },
          // { value: '原价总额' },
          // { value: '折扣' },
          {},
          { value: '需付金额' }
        ]}
      />
      <div className={'item-container'}>
        {formatLessonItems(Items).map(({ code, name, items }, i) => (
          <div key={i} className={'item-row'}>
            <TableRow
              rowClassName={'bold'}
              data={[
                { value: code },
                { value: name }
              ]}
            />
            {items.map(({ name, qty, price, totalPrice, discount }, j) => (
              <TableRow
                key={j}
                data={[
                  {},
                  { value: name },
                  {},
                  {},
                  { value: qty },
                  // { value: price, CellComponent: Currency },
                  // { value: totalPrice, CellComponent: Currency },
                  // { value: -discount, CellComponent: Currency },
                  {},
                  { value: totalPrice - discount, CellComponent: Currency }
                ]}
              />
            ))}
          </div>
        ))}
        {
          Depositpayment > 0 &&
          <TableRow
            rowClassName={'bold'}
            data={[
              {},
              { value: '积分扣减' },
              {},
              {},
              { value: 1},
              {},
              { value: -1 * Depositpayment, CellComponent: Currency }
            ]}
          />
        }
      </div>
    </div>
  );
};

export default Table;